import styled from 'styled-components';
import HSBar from 'react-horizontal-stacked-bar-chart';
import { Text } from '@uhg-harmony/uitk-react';

export const StyledHSBar = styled(HSBar)`
  margin-top: 1rem;
`;

export const StyledLink = styled(Text)`
  font-family: OptumSans, sans-serif;
  color: blue;
  font-size: 0.875rem;
  cursor: pointer;
`;
